import { getRemoteConfigByKey } from '@/feature/analytics/hooks/use-firebase-remote-config';
import { FirebaseRemoteSettings } from '@/feature/analytics/utils/firebaseSettings';
import { useLocalFlagsStore } from '@/feature/devsettings/hooks/use-dev-settings';

// It is intended for A/B testing to determine whether to display the Date of Birth (DOB) first in the KYC flow.
// https://pitchtech.atlassian.net/browse/CSP-887
export const isDobFirstAB = (): boolean => getRemoteConfigByKey(FirebaseRemoteSettings.KYC_DOB_FIRST).asBoolean();

// Returns true if fantasy cash-out is enabled via Firebase Remote Config or overridden in Dev Settings.
export const useFantasyCashoutEnabled = (): boolean => {
    const { localFlags } = useLocalFlagsStore();
    const firebaseValue = getRemoteConfigByKey(FirebaseRemoteSettings.FANTASY_CASHOUT_ENABLED).asBoolean();
    return localFlags?.fantasyCashoutEnabled?.enabled || firebaseValue;
};

export const shouldKeepFantasyLiveRemovedMarkets = (): boolean => {
    const { localFlags } = useLocalFlagsStore.getState();
    const firebaseValue = getRemoteConfigByKey(
        FirebaseRemoteSettings.FANTASY_KEEP_LIVE_REMOVED_PROJECTIONS
    ).asBoolean();
    return localFlags?.fantasyKeepLiveRemovedProjections?.enabled || firebaseValue;
};
